var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVerify(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.7793 14.0001L12.591 16.8234L18.226 11.1768",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5443 2.85805C13.3493 2.16971 14.6676 2.16971 15.4843 2.85805L17.3276 4.44471C17.6776 4.74805 18.331 4.99305 18.7976 4.99305H20.781C22.0176 4.99305 23.0326 6.00805 23.0326 7.24471V9.22805C23.0326 9.68305 23.2776 10.348 23.581 10.698L25.1676 12.5414C25.856 13.3464 25.856 14.6647 25.1676 15.4814L23.581 17.3247C23.2776 17.6747 23.0326 18.328 23.0326 18.7947V20.778C23.0326 22.0147 22.0176 23.0297 20.781 23.0297H18.7976C18.3426 23.0297 17.6776 23.2747 17.3276 23.578L15.4843 25.1647C14.6793 25.853 13.361 25.853 12.5443 25.1647L10.701 23.578C10.351 23.2747 9.69763 23.0297 9.23096 23.0297H7.21263C5.97596 23.0297 4.96096 22.0147 4.96096 20.778V18.783C4.96096 18.328 4.71596 17.6747 4.4243 17.3247L2.8493 15.4697C2.17263 14.6647 2.17263 13.358 2.8493 12.553L4.4243 10.698C4.71596 10.348 4.96096 9.69471 4.96096 9.23971V7.23305C4.96096 5.99638 5.97596 4.98138 7.21263 4.98138H9.23096C9.68596 4.98138 10.351 4.73638 10.701 4.43305L12.5443 2.85805Z",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerify);
export default __webpack_public_path__ + "static/media/verify.d0c61f966b788a8596a2a7bad25844f6.svg";
export { ForwardRef as ReactComponent };